import { css } from "styled-components";
import { textUppercaseMixin } from "../../shared/mixins/typography";
import { palette } from "../palette";
const fontBeaufort = [
    "LoL Display",
    "Beaufort for LOL",
    "Times New Roman",
    "Times",
    "Baskerville",
    "Georgia",
    "serif",
].join(",");
export const cssFontFamilySerif = css `
  font-family: ${fontBeaufort};

  &:lang(ko-kr) {
    font-family: "Noto Sans", sans-serif;
    font-weight: normal;
    word-break: keep-all;
  }
`;
const fontSpeigel = ["LoL Body", "Spiegel", "Arial", "Helvetica Neue", "Helvetica", "sans-serif"].join(",");
export const cssFontFamilySansSerif = css `
  font-family: ${fontSpeigel};

  &:lang(vi-vn) {
    /* TODO define locale specific fonts */
  }

  &:lang(ko-kr) {
    font-family: "Noto Sans", sans-serif;
    font-weight: normal;
    word-break: keep-all;
  }
`;
const typekitBase = css `
  user-select: none;
  font-kerning: normal;
  font-feature-settings: "kern" 1;
  -webkit-font-smoothing: antialiased;

  &:lang(ko-kr) {
    /* Bugfix for korean characters getting random linebreaks. */
    letter-spacing: 0;
  }
`;
const cssTypographyHeadingBase = css `
  ${typekitBase}
  ${cssFontFamilySerif};
  ${textUppercaseMixin}
  color: ${palette.gold1};
`;
export const cssTypographyH1 = css `
  ${cssTypographyHeadingBase}
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0.05em;
`;
export const cssTypographyH2 = css `
  ${cssTypographyHeadingBase}
  font-size: 30px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.05em;
`;
export const cssTypographyH3 = css `
  ${cssTypographyHeadingBase}
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.05em;
`;
export const cssTypographyH4 = css `
  ${cssTypographyHeadingBase}
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.05em;
`;
export const cssTypographyH5 = css `
  ${cssTypographyHeadingBase}
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.075em;
`;
export const cssTypographyH6 = css `
  ${cssTypographyHeadingBase}
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.075em;
`;
export const cssTypographyTextLarge = css `
  ${typekitBase}
  ${cssFontFamilySerif};
  color: ${palette.grey1};
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0.05em;
`;
export const cssTypographyTextMedium = css `
  ${typekitBase}
  ${cssFontFamilySansSerif};
  color: ${palette.grey1};
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0.025em;
`;
export const cssTypographyTextSmall = css `
  ${typekitBase}
  ${cssFontFamilySansSerif};
  color: ${palette.grey1};
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0.05em;
`;
export const cssTypographyTextXSmall = css `
  ${cssTypographyTextSmall}
  font-size: 10px;
  line-height: 14px;
`;
export const cssTypographyButton = css `
  ${typekitBase}
  ${cssFontFamilySerif};
  ${textUppercaseMixin}
  color: ${palette.gold3};
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.065em;
  text-decoration: none;
`;
export const cssTypographyLabel = css `
  ${typekitBase}
  ${cssFontFamilySansSerif};
  color: ${palette.grey1};
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.1em;
  line-height: 16px;
`;
const cssTypographyNavBase = css `
  ${typekitBase}
  ${cssFontFamilySerif};
  ${textUppercaseMixin}
  color: ${palette.gold2};
  font-weight: 700;

  &.active {
    color: ${palette.gold1};
  }

  &:hover {
    color: ${palette.gold1};
  }
`;
export const cssTypographyNavMain = css `
  ${cssTypographyNavBase}
  font-size: 14px;
  letter-spacing: 0.075em;
`;
export const cssTypographyNavSecondary = css `
  ${cssTypographyNavBase}
  font-size: 12px;
  letter-spacing: 0.1em;
`;
export const cssTypographyModifierPreserveCase = css `
  text-transform: none;
  letter-spacing: 0.0375em;
`;
export const cssTypographyModifierUppercase = css `
  ${textUppercaseMixin}
`;
export const cssTypographyModifierHighlight = css `
  color: ${palette.gold1};
`;
export const cssTypographyModifierSubhead = css `
  color: ${palette.grey1};
`;
//# sourceMappingURL=typography.js.map